import { Component, type ErrorInfo, type ReactNode } from 'react'
import { Button } from '../ui/Button'

interface State { error: Error | null }

export class RootErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State { return { error } }

  componentDidCatch(error: Error, info: ErrorInfo): void { console.error('Console route failed', error, info) }

  render() {
    if (!this.state.error) return this.props.children
    return <main className="fatal-state"><h1>We could not render this screen</h1><p>Refresh the console to try again. Your wallet and signed transactions are not held here.</p><Button onClick={() => window.location.reload()}>Refresh</Button></main>
  }
}
